import { Descriptions, DescriptionsProps } from "antd";
import { Invoice } from "../../repository/data.default";
import dayjs from "dayjs";

export interface InvoiceDetailsProps {
  invoice?: Invoice;
}

function InvoiceDetails({ invoice }: InvoiceDetailsProps) {
  const items: DescriptionsProps["items"] = [
    {
      key: "1",
      label: "Company",
      children: <span>{checkInvoiceDetail(invoice?.companyName)}</span>,
    },
    {
      key: "5",
      label: "Paid",
      children: <span>{invoice?.isPaid ? "Yes" : "No"}</span>,
    },
    {
      key: "7",
      label: "Due Date",
      children: <span>{checkInvoiceDetail(invoice?.dueDate)}</span>,
    },
    {
      key: "4",
      label: "Tenant",
      children: <span>{checkInvoiceDetail(invoice?.tenantName)}</span>,
    },
    {
      key: "8",
      label: "Items",
      children: <span>{checkInvoiceDetail(invoice?.itemsCount)}</span>,
    },
    {
      key: "2",
      label: "Total Amount",
      children: <span>{checkInvoiceDetail(invoice?.totalAmount)} €</span>,
    },
    {
      key: "10",
      label: "Description",
      children: (
        <p style={{ padding: "0px", margin: "0px", textAlign: "justify" }}>
          {checkInvoiceDetail(invoice?.description)}
        </p>
      ),
      span: 3,
    },
  ];

  //Methods
  function checkInvoiceDetail(detail: any) {
    if (detail) {
      const dateFormat = /^\d{4}\-\d{2}\-\d{2}$/;
      const isDate = dateFormat.test(detail);

      if (isDate) {
        return dayjs(detail).format("DD/MM/YYYY");
      }

      return detail;
    }

    return "-";
  }

  return <Descriptions size={"small"} bordered items={items} />;
}

export default InvoiceDetails;
